const userDataFormFR = {
    "view": {
        "title": "Complétez vos informations",
        "stepZero": {
            "title": "Déclaration",
            "form": {
                "label": {
                    "declarationPoint1": "En fournissant ces informations, vous reconnaissez et acceptez qu'elles seront fournies au mieux de vos connaissances et capacités. Nous nous efforçons de garantir que toutes les informations sont exactes et véridiques.",
                    "declarationPoint2": "Veuillez noter que fournir de fausses informations ou déformer la vérité peut avoir des conséquences importantes. Nous exhortons tous les utilisateurs à vérifier les informations qu'ils fournissent et à utiliser cette plateforme de manière responsable.",
                    "declarationPoint3": "La responsabilité de toute désinformation ou erreur incombe uniquement à la personne fournissant les informations. Nous n'assumons aucune responsabilité pour les conséquences des informations incorrectes ou trompeuses fournies par les utilisateurs.",
                    "declarationPoint4": "En cliquant sur <strong>'Suivant'</strong>, vous consentez à ces termes et affirmez que vous êtes pleinement conscient des implications de fournir des informations inexactes ou fausses.",
                    "declarationAgreement": "Je suis entièrement d'accord et comprends les termes ci-dessus."
                },
                "button": {
                    "next": "Suivant"
                }
            }
        },
        "stepOne": {
            "title": "Informations personnelles",
            "form": {
                "label": {
                    "firstName": "Prénom",
                    "lastName": "Nom de famille",
                    "streetAndNumber": "Rue et numéro",
                    "zipCode": "Code postal",
                    "city": "Ville",
                    "country": "Pays"
                },
                "placeholder": {
                    "country": "Sélectionnez le pays"
                },
                "help_text": {
                    "firstName": "Si vous vous inscrivez en tant que SARL ou autre entité commerciale, ce champ sera utilisé pour le prénom du PDG.",
                    "lastName": "Si vous vous inscrivez en tant que SARL ou autre entité commerciale, ce champ sera utilisé pour le nom de famille du PDG.",
                    "country": "Si vous vous inscrivez en tant que SARL ou autre entité commerciale, ce champ sera utilisé pour le pays du PDG."
                },
                "button": {
                    "next": "Suivant"
                }
            }
        },
        "stepTwo": {
            "title": "Informations commerciales",
            "form": {
                "label": {
                    "businessType": "Type d'entreprise",
                    "companyName": "Nom de l'entreprise",
                    "businessStreet": "Rue et numéro",
                    "businessCity": "Ville",
                    "businessZip": "Code postal",
                    "businessCountry": "Pays",
                    "ceoFirstName": "Représentant légal / Prénom du PDG",
                    "ceoLastName": "Représentant légal / Nom de famille du PDG",
                    "tradeRegistryExport": "Extrait du registre du commerce",
                    "tradeRegistryCompanyUrl": "URL de l'entreprise au registre du commerce",
                    "vatNumber": "Numéro de TVA",
                    "taxNumber": "Numéro fiscal"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Entreprise individuelle",
                        "limitedLiabilityCompany": "Société à responsabilité limitée",
                        "partnershipOrganized": "Société en nom collectif",
                        "publicLimitedCompanyByShares": "Société anonyme par actions",
                        "other": "Autre"
                    }
                },
                "placeholder": {
                    "businessType": "Sélectionnez le type d'entreprise",
                    "businessCountry": "Sélectionnez le pays"
                },
                "help_text": {
                    "companyName": "Le nom de l'entreprise doit être conforme à ce qui a été initialement soumis dans Stripe. Ne changez que s'il diffère de ce qui a été initialement soumis.",
                    "tradeRegistryExport": "Veuillez fournir un extrait officiel du registre du commerce de votre entreprise. PDF uniquement, taille maximale du fichier 5 Mo. Si vous avez besoin d'aide pour trouver votre extrait du registre du commerce, veuillez contacter le registre de votre pays. Une liste non officielle des registres peut être trouvée <1>ici</1>.",
                    "tradeRegistryCompanyUrl": "Veuillez fournir l'URL de votre entreprise au registre du commerce de votre pays. Si votre registre ne le permet pas, veuillez insérer uniquement une URL de registre."
                },
                "button": {
                    "previous": "Précédent",
                    "next": "Suivant"
                }
            }
        },
        "stepThree": {
            "title": "Confirmation",
            "form": {
                "label": {
                    "personalInformation": "Informations personnelles",
                    "personalName": "Nom",
                    "personalAddress": "Adresse",
                    "businessInformation": "Informations commerciales",
                    "companyName": "Entreprise",
                    "ceoName": "Nom du PDG",
                    "businessAddress": "Adresse",
                    "businessType": "Type d'entreprise",
                    "taxNumber": "Numéro fiscal",
                    "vatNumber": "Numéro de TVA",
                    "tradeRegistryExportUploaded": "Extrait du registre du commerce téléchargé",
                    "tradeRegistryCompanyUrl": "URL de l'entreprise au registre du commerce",
                    "notAvailable": "N/A"
                },
                "button": {
                    "previous": "Précédent",
                    "save": "Enregistrer",
                    "next": "Suivant"
                }
            },
            "message": {
                "success": "Vos informations ont été mises à jour !",
                "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Soumettez vos informations",
                    "body": {
                        "point1": "En cliquant sur <strong>'Confirmer'</strong>, vous affirmez que toutes les informations que vous avez fournies sont exactes et véridiques au mieux de vos connaissances.",
                        "point2": "Confirmez-vous que tous les détails fournis sont corrects et reconnaissez-vous les conséquences potentielles de la soumission d'informations inexactes ?"
                    },
                    "button": {
                        "confirm": "Confirmer",
                        "cancel": "Annuler"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Vérifiez le numéro de mobile",
            "form": {
                "label": {
                    "mobileNumber": "Entrez votre numéro de mobile",
                    "deliveryMedium": "Moyen de livraison : ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Remarque : Le numéro de mobile est requis pour la vérification en tant que procédure standard car il peut être utilisé pour la validation de connexion. Vous devez posséder le numéro et y avoir accès pour un processus de vérification fluide.",
                    "isFormUSorCanada": "* Si vous êtes basé aux États-Unis ou au Canada, veuillez contacter notre équipe de support après avoir inséré votre numéro de mobile.",
                    "deliveryMediumWhatsapp": "Remarque : Veuillez vous assurer que vous avez un compte WhatsApp sur ce numéro pour recevoir le message.",
                    "otp": "Veuillez entrer l'OTP envoyé à votre numéro de mobile."
                },
                "message": {
                    "errorMobileNumberEmpty": "Le numéro de mobile est requis.",
                    "errorMobileNumberInvalid": "Numéro de mobile invalide.",
                    "errorMobileNumberSame": "Ce numéro est déjà ajouté et vérifié avec votre compte.",
                    "errorOTPRequired": "L'OTP est requis.",
                    "errorOtpSendLimitExhasuted": "Vous ne pouvez plus demander d'OTP car vous avez épuisé la <strong>limite MAX ({{maxLimit}})</strong> pour les demandes d'OTP. Veuillez contacter le support pour plus d'informations !",
                    "errorMobileUpdateLimitExhausted": "Vous ne pouvez pas mettre à jour votre numéro de mobile car vous l'avez déjà mis à jour MAX ({{maxLimit}}) fois. Veuillez contacter le support pour plus d'informations !"
                },
                "button": {
                    "sendOTP": "Envoyer OTP",
                    "next": "Suivant",
                    "confirm": "Confirmer",
                    "notGettingCode": "Je ne reçois pas le code"
                }
            },
            "message": {
                "success": "Numéro de mobile vérifié !",
                "errorValidatingOTP": "Erreur lors de la validation de l'OTP !",
                "errorSendingOTP": "Il y a eu un problème lors de l'envoi du code OTP, veuillez réessayer plus tard !"
            },
            "modal": {
                "notGettingCode": {
                    "header": "Je ne reçois pas le code",
                    "body": {
                        "point1": "Il semble qu'il y ait un problème pour vous envoyer un code de vérification pour le moment. Veuillez réessayer plus tard",
                        "point2": "Pour obtenir de l'aide, veuillez contacter notre support via le Centre d'aide."
                    },
                    "button": {
                        "close": "Fermer"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "Vous pouvez demander à nouveau l'OTP dans <strong>{{secondsRemaining}}</strong> secondes"
                }
            }
        },
        "stepFive": {
            "title": "Vérification d'identité",
            "form": {
                "label": {
                    "identityVerificationDescription": "Veuillez cliquer sur le lien ci-dessous pour commencer la vérification d'identité.",
                    "identityVerificationResults": "Résultats de la vérification d'identité"
                },
                "button": {
                    "loading": "Chargement...",
                    "verifyIdentity": "Vérifier l'identité"
                },
                "table": {
                    "column": {
                        "type": "Type",
                        "status": "Statut",
                        "details": "Détails"
                    },
                    "label": {
                        "selfieVerification": "Vérification de selfie",
                        "documentVerification": "Vérification de document",
                        "verified": "Vérifié",
                        "notVerified": "Non vérifié",
                        "notAvailable": "N/A"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Vos informations d'identité ont été vérifiées, notre équipe examinera les informations d'identité et donnera l'approbation finale dans 2-3 jours ouvrables.",
                    "identityVerificationFailed": "Vos informations d'identité n'ont pas pu être vérifiées, veuillez soumettre à nouveau les informations ! Il vous reste seulement <strong>{{attemptsRemaining}}</strong> tentative pour vérifier votre identité.",
                    "identityVerificationMaxAttempts": "Vous avez épuisé le nombre maximum de tentatives pour la vérification d'identité, veuillez contacter le support pour plus d'informations."
                }
            }
        },
        "stepSix": {
            "title": "Signer le contrat",
            "form": {
                "label": {
                    "signContract": "Signer le contrat"
                }
            }
        },
        "stepSeven": {
            "title": "Approbation",
            "form": {
                "message": {
                    "approval": "Notre équipe examinera toutes les informations fournies par vous et donnera l'approbation finale dans un délai de 3 jours ouvrables."
                }
            }
        }
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Signature du contrat réussie :)",
            "description": "Vous avez signé votre contrat avec succès, le statut sera mis à jour dans votre compte sous peu, veuillez rafraîchir la page dans quelques secondes."
        },
        "signLater": {
            "title": "Signature du contrat plus tard ...",
            "description": "Vous avez choisi de signer le contrat plus tard, veuillez compléter cette étape au plus tôt pour bénéficier de la distribution."
        },
        "signDeclined": {
            "title": "Signature du contrat refusée :(",
            "description": "Vous avez refusé de signer le contrat, cela retardera le processus pour activer la distribution."
        },
        "signCompleted": {
            "title": "Signature du contrat terminée :)",
            "description": "Votre contrat a été finalisé, le statut sera mis à jour dans votre compte sous peu, veuillez rafraîchir la page dans quelques secondes."
        }
    }
};

export default userDataFormFR;